export const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 20 20" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0
      10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10.75
      7C10.75 6.58579 10.4142 6.25 10 6.25C9.58579 6.25 9.25 6.58579 9.25
      7L9.25 9.25002H7C6.58579 9.25002 6.25 9.58581 6.25 10C6.25 10.4142 6.58579
      10.75 7 10.75H9.25V13C9.25 13.4142 9.58578 13.75 10 13.75C10.4142 13.75 10.75
      13.4142 10.75 13L10.75 10.75H13C13.4142 10.75 13.75 10.4142 13.75 10C13.75 9.58581
      13.4142 9.25002 13 9.25002H10.75V7Z"
      fill="#098F50"
    />
  </svg>
)
